<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn icon @click="back()">
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
						{{ $t("title.edit_user") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<form-user-central
							v-model="item"
							:tenants="tenants"
							:outlets="outlets"
							:roles="roles"
							@changeTenant="onChangeTenant()"
						></form-user-central>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Update") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>

<script>
import FormUserCentral from "../../../forms/FormUserCentral.vue";
export default {
	components: { FormUserCentral },
	props: {
		data: Object,
		roles: Array,
		tenants: Array,
		outlets: Array,
	},
	data() {
		return {
			item: this.$inertia.form(this.data),
		};
	},

	methods: {
		submit() {
			this.item.put(this.$route("central.users.update", this.item.uuid));
		},

		onChangeTenant() {
			this.item.outlet_ids = [];
			this.$inertia.reload({
				only: ["outlets"],
				data: {
					tenant_id: this.item.tenant_id,
				},
			});
		},

		back() {
			window.history.back();
		},
	},
};
</script>